import { Component, Input, OnInit } from '@angular/core';
import { ProductApiService } from 'src/app/services/api/product-api.service';

@Component({
  selector: 'app-platform-list',
  templateUrl: './platform-list.component.html',
  styleUrls: ['./platform-list.component.scss'],
})
export class PlatformListComponent implements OnInit {
  @Input() categoryID = 0;
  @Input() platforms: any[] = [];

  constructor(private api: ProductApiService) {}

  ngOnInit(): void {
    // this.findPlatforms();
  }

  // loading = false;
  // platforms: any[] = [];
  // async findPlatforms() {
  //   try {
  //     this.loading = true;
  //     const r = await this.api.findPlatformsByCategory(this.categoryID);
  //     this.platforms = r.data;
  //   } catch (error) {
  //   } finally {
  //     this.loading = false;
  //   }
  // }
}
